import { Controller } from "@hotwired/stimulus"
import { Autocomplete } from "stimulus-autocomplete"

// Connects to data-controller="linked-autocomplete"
export default class extends Controller {
  static targets = ["codeStudyInput", "codeStudyHidden", "codeStudyResults",
                    "studyInput", "studyHidden", "studyResults"]

  static values = {
    url: String,
    modality: String,
    modalitySelector: String
  }

  connect() {
    this.setupAutocomplete("code-study")
    this.setupAutocomplete("study")
    this.bindModalitySelector()
    this.toggleInputsByModality()
  }

  disconnect() {
    if (this.modalityField && this.onModalityChanged) {
      this.modalityField.removeEventListener("change", this.onModalityChanged)
    }
  }

  setupAutocomplete(field) {
    const inputTarget = field === "code-study" ? this.codeStudyInputTarget : this.studyInputTarget
    const resultsTarget = field === "code-study" ? this.codeStudyResultsTarget : this.studyResultsTarget

    inputTarget.addEventListener("input", (e) => this.handleInput(e, field))
    resultsTarget.addEventListener("click", (e) => this.handleSelect(e, field))
  }

  handleInput = (event, field) => {
    if (!this.currentModality()) {
      this.toggleInputsByModality()
      const resultsTarget = field === "code-study" ? this.codeStudyResultsTarget : this.studyResultsTarget
      resultsTarget.innerHTML = ""
      resultsTarget.classList.add("d-none")
      return
    }

    const query = event.target.value
    if (query.length < 1) {
      const resultsTarget = field === "code-study" ? this.codeStudyResultsTarget : this.studyResultsTarget
      resultsTarget.innerHTML = ""
      resultsTarget.classList.add("d-none")
      return
    }

    const params = new URLSearchParams()
    params.append('q', query)
    const dynamicModality = this.currentModality()
    if (dynamicModality) {
      params.append('modality', dynamicModality)
    }

    fetch(`${this.urlValue}?${params.toString()}`)
      .then(response => response.text())
      .then(html => {
        const resultsTarget = field === "code-study" ? this.codeStudyResultsTarget : this.studyResultsTarget
        resultsTarget.innerHTML = html
        resultsTarget.classList.remove("d-none")
      })
      .catch(error => console.error("Error:", error))
  }

  handleSelect = (event, field) => {
    const option = event.target.closest("li[data-autocomplete-value]")
    if (!option) return

    event.preventDefault()
    event.stopPropagation()

    const codigoValue = option.getAttribute("data-codigo-value")
    const estudioValue = option.getAttribute("data-estudio-value")

    if (field === "code-study") {
      this.codeStudyInputTarget.value = codigoValue
      this.codeStudyHiddenTarget.value = codigoValue
      this.studyInputTarget.value = estudioValue
      this.studyHiddenTarget.value = estudioValue
    } else {
      this.studyInputTarget.value = estudioValue
      this.studyHiddenTarget.value = estudioValue
      this.codeStudyInputTarget.value = codigoValue
      this.codeStudyHiddenTarget.value = codigoValue
    }

    this.codeStudyResultsTarget.classList.add("d-none")
    this.studyResultsTarget.classList.add("d-none")
    this.codeStudyResultsTarget.innerHTML = ""
    this.studyResultsTarget.innerHTML = ""
  }

  currentModality() {
    if (this.hasModalitySelectorValue) {
      const field = document.querySelector(this.modalitySelectorValue)
      const value = field?.value?.trim()
      if (value) return value
    }

    if (this.hasModalityValue) {
      const value = this.modalityValue?.trim()
      if (value) return value
    }

    return null
  }

  bindModalitySelector() {
    if (!this.hasModalitySelectorValue) return

    this.modalityField = document.querySelector(this.modalitySelectorValue)
    if (!this.modalityField) return

    this.onModalityChanged = () => this.toggleInputsByModality()
    this.modalityField.addEventListener("change", this.onModalityChanged)
  }

  toggleInputsByModality() {
    if (!this.hasModalitySelectorValue) return

    const enabled = !!this.currentModality()
    const placeholder = enabled ? "Buscar prestación..." : "Seleccione modalidad primero"

    this.codeStudyInputTarget.disabled = !enabled
    this.studyInputTarget.disabled = !enabled
    this.studyInputTarget.placeholder = placeholder

    if (!enabled) {
      this.codeStudyInputTarget.value = ""
      this.codeStudyHiddenTarget.value = ""
      this.studyInputTarget.value = ""
      this.studyHiddenTarget.value = ""
      this.codeStudyResultsTarget.innerHTML = ""
      this.studyResultsTarget.innerHTML = ""
      this.codeStudyResultsTarget.classList.add("d-none")
      this.studyResultsTarget.classList.add("d-none")
    }
  }
}
